<template>
    <div class="audit-log-toolbar">
        <div class="section-header-compact">
            <div class="section-actions">
                <CarbonSelect
                    v-model="local.entity"
                    :options="entityOptions"
                    placeholder="전체 엔티티"
                    :placeholderDisabled="false"
                />
                <CarbonSelect
                    v-model="local.action"
                    :options="actionOptions"
                    placeholder="전체 액션"
                    :placeholderDisabled="false"
                />
                <div class="date-picker-wrapper">
                    <DatePicker
                        v-model="local.startDate"
                        type="date"
                        format="YYYY-MM-DD"
                        value-type="format"
                        placeholder="시작일"
                        :append-to-body="true"
                        :popup-style="{ zIndex: 1050 }"
                    />
                </div>
                <div class="date-picker-wrapper">
                    <DatePicker
                        v-model="local.endDate"
                        type="date"
                        format="YYYY-MM-DD"
                        value-type="format"
                        placeholder="종료일"
                        :append-to-body="true"
                        :popup-style="{ zIndex: 1050 }"
                    />
                </div>
                <!-- <CarbonInput
                    v-model.number="local.entityIdx"
                    type="number"
                    placeholder="대상 번호"
                    custom-class="input-num"
                /> -->
                <CarbonInput v-model="local.worker" placeholder="작업자" />
                <CarbonButton @click="reset">초기화</CarbonButton>
                <CarbonButton variant="search" icon="fas fa-search" @click="apply">조회</CarbonButton>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import CarbonButton from "../../common/CarbonButton.vue";
import CarbonInput from "../../common/CarbonInput.vue";
import CarbonSelect from "../../common/CarbonSelect.vue";

export default {
    name: "AuditLogFilters",
    components: { DatePicker, CarbonButton, CarbonInput, CarbonSelect },
    props: {
        value: { type: Object, default: () => ({}) },
        entityOptions: { type: Array, default: () => [] },
        actionOptions: { type: Array, default: () => [] },
    },
    data() {
        return {
            local: {
                entity: "",
                action: "",
                entityIdx: undefined,
                worker: "",
                startDate: "",
                endDate: "",
            },
        };
    },
    watch: {
        value: {
            deep: true,
            handler(v) {
                this.local = { ...this.local, ...v };
            },
        },
    },
    created() {
        this.local = { ...this.local, ...this.value };
    },
    methods: {
        apply() {
            const out = {};
            if (this.local.entity) out.entity = this.local.entity;
            if (this.local.action) out.action = this.local.action;
            if (this.local.entityIdx) out.entityIdx = this.local.entityIdx;
            const workerTrimmed = (this.local.worker || "").trim();
            if (workerTrimmed) out.worker = workerTrimmed;
            if (this.local.startDate) out.startDate = this.local.startDate;
            if (this.local.endDate) out.endDate = this.local.endDate;
            this.$emit("input", out);
            this.$emit("apply", out);
        },
        reset() {
            this.local = {
                entity: "",
                action: "",
                entityIdx: undefined,
                worker: "",
                startDate: "",
                endDate: "",
            };
            this.$emit("input", {});
            this.$emit("apply", {});
        },
    },
};
</script>

<style scoped>
/* ActivityConfigToolbar와 동일한 툴바 스타일 */
.audit-log-toolbar .section-header-compact {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
}
/* 한 줄 배치 (공통 컴포넌트 적용 전과 동일) */
.audit-log-toolbar .section-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: nowrap;
}
.audit-log-toolbar .section-actions > * {
    flex-shrink: 0;
}
/* Carbon 컴포넌트가 100% width로 줄바꿈 유발하지 않도록 툴바 한정 너비 */
.audit-log-toolbar .section-actions :deep(.carbon-select) {
    width: auto;
    min-width: 100px;
    max-width: 160px;
}
.audit-log-toolbar .section-actions :deep(.carbon-input) {
    width: auto;
    min-width: 80px;
    max-width: 140px;
}
.audit-log-toolbar .section-actions :deep(.carbon-input.input-num) {
    max-width: 90px;
}
.audit-log-toolbar .section-actions :deep(.carbon-btn) {
    flex-shrink: 0;
}
.audit-log-toolbar .input-compact {
    min-width: 100px;
}
.audit-log-toolbar .input-num {
    min-width: 80px;
}
/* vue2-datepicker 툴바와 맞춤 */
.audit-log-toolbar .date-picker-wrapper {
    display: inline-block;
}
.audit-log-toolbar .date-picker-wrapper :deep(.mx-datepicker) {
    width: 130px;
}
.audit-log-toolbar .date-picker-wrapper :deep(.mx-input-wrapper .mx-input) {
    padding: 6px 10px;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    font-size: 12px;
    height: auto;
}
.audit-log-toolbar .date-picker-wrapper :deep(.mx-input-wrapper .mx-input:focus) {
    border-color: #52b788;
    outline: none;
}
.audit-log-toolbar .date-picker-wrapper :deep(.mx-datepicker-popup) {
    z-index: 1050;
}
@media (max-width: 768px) {
    .audit-log-toolbar .section-actions {
        flex-direction: column;
        align-items: stretch;
    }
    .audit-log-toolbar .section-actions > * {
        width: 100%;
    }
    .audit-log-toolbar .date-picker-wrapper :deep(.mx-datepicker) {
        width: 100%;
    }
}
</style>
